var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.fullScreen)?_c('div',{staticClass:"full-screen"},[_c('div',{staticClass:"body"},[_vm._t("default")],2),_c('div',{staticClass:"btn-exit clickable",on:{"click":_vm.clickExit}},[_vm._v("退出")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }